<template>
    <div class="buriedParamSet">
       <el-form ref="form" label-width="100px" class="attr_common" label-position="left" :inline="true">
            <el-form-item label="方案名称:">
                <el-input v-model="curSuggestion.name" class="input-box" :disabled="!updateFlag"></el-input>
            </el-form-item>

            <el-form-item label="土壤温度:">
                <el-input v-model="curSuggestion.soilTempe" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">℃</span>
            </el-form-item>
            <el-form-item label="埋设深度:">
                <el-input v-model="curSuggestion.buriedDepth" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">m</span>
            </el-form-item>

            <el-form-item label="土壤导热系数:" class="form-row">
                <el-input v-model="curSuggestion.soilThermConduct" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">w/(m·℃)</span>
                <el-button size="small" type="text" @click="calculateThermal" class="calculate-btn" :disabled="!updateFlag">计算</el-button>
                <el-button size="small" type="text" @click="searchThermal" :disabled="!updateFlag">查表</el-button>
            </el-form-item>

        </el-form>


        <!--温压测点方案设置-->
        <el-table
            :data="suggestions"
            border
            style="width: 100%"
            class="custom-table"
            max-height="300"
            highlight-current-row
            row-class-name="custom-row"
            cell-class-name="custom-cell"
            header-row-class-name="custom-header"
            @current-change="suggestionChange"
            ref="suggestionsTable">

            <el-table-column
                prop="id"
                width="50"
                label="编号">
            </el-table-column>
            <el-table-column
                prop="name"
                label="方案名称">
            </el-table-column>
            <el-table-column
                prop="soilQuality"
                label="土质">
            </el-table-column>
            <el-table-column
                prop="soilMoistSat"
                label="土壤含水饱和率">
            </el-table-column>
            <el-table-column
                prop="soilPorosity"
                label="土壤孔隙率">
            </el-table-column>
            <el-table-column
                prop="soilTempe"
                label="土壤温度">
            </el-table-column>
            <el-table-column
                prop="soilThermConduct"
                label="土壤导热系数">
            </el-table-column>
            <el-table-column
                prop="buriedDepth"
                label="埋设深度">
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <el-button @click="defaultSuggestion(scope.row)" type="text" size="small" v-if="defaultSug.id!=scope.row.id">设为默认</el-button>
                    <span v-else>默认</span>
                </template>
            </el-table-column>
        </el-table>

        <div class="foot-btn">
            <el-button size="medium" type="primary" @click="addSuggestion" v-if="!updateFlag">新增</el-button>
            <el-button size="medium" type="primary" @click="updateSuggestion" v-if="!updateFlag">修改</el-button>
            <el-button size="medium" type="primary" @click="deleteSuggestion" v-if="!updateFlag&&this.suggestions.length>1">删除</el-button>
            <el-button size="medium" type="primary" @click="saveSuggestion" v-if="updateFlag">保存</el-button>
            <el-button size="medium" type="primary" @click="cancelSuggestion" v-if="updateFlag">取消</el-button>
        </div>

        <!--土壤导热系数-->
        <el-dialog
            class="thermal-dialog"
            :visible.sync="thermal"
            append-to-body>
            <span slot="title" v-if="thermalMode=='table'">土壤导热系统-查表</span>
            <span slot="title" v-else>土壤导热系统-计算</span>

            <div class="thermal-content thermal-table" v-if="thermalMode=='table'">
                <img :src="baseUrl + '/img/simulation/thermal.jpg'" class="thermal-img"/>
            </div>
            <div class="thermal-content thermal-calculate" v-else>
                <el-form ref="form" label-width="140px" class="attr_common" label-position="left">
                    <el-form-item label="土质:">
                        <el-select v-model="curSuggestion.soilQuality" placeholder="请选择" class="input-box" value-key="id">
                            <el-option
                                v-for="item in soilQualitys"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="土壤孔隙率:">
                        <el-input v-model="curSuggestion.soilPorosity" class="input-box"></el-input>
                    </el-form-item>
                    <el-form-item label="土壤含水饱和率:">
                        <el-input v-model="curSuggestion.soilMoistSat" class="input-box"></el-input>
                    </el-form-item>
                   
                </el-form>
                <div class="foot-btn">
                    <el-button size="small" @click="thermalOk">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import _remove from "lodash/remove";
import _find from "lodash/find";

export default {
    name:"overHeadParamSet",
    computed:{
        // 全局配置
        globalConfig(){
            return this.$store.state.simulation.globalConfig;
        }
    },
    data(){
        return {
            curSuggestion:{
                id:1,
                name:"默认方案",
                soilQuality:"粗沙", // 土质选择
                soilMoistSat:0.3, // 土壤含水饱和率
                soilPorosity:0, // 土壤孔隙率
                soilTempe:10, // 土壤温度
                soilThermConduct:1.2, // 土壤导热系数
                buriedDepth:1.4, // 埋设深度                
            } , // 当前属性

            soilQualitys:[
                {   
                    id:1,
                    name:"中细沙"
                },
                {
                    id:2,
                    name:"黏土"
                },
                {
                    id:3,
                    name:"有机土",
                },
                {
                    id:4,
                    name:"碎石",
                },
                {
                    id:0,
                    name:"粗沙"
                },
            ], // 土质
            suggestions:[{
                id:1,
                name:"默认方案",
                soilQuality:"粗沙", // 土质选择
                soilMoistSat:0.3, // 土壤含水饱和率
                soilPorosity:0, // 土壤孔隙率
                soilTempe:10, // 土壤温度
                soilThermConduct:1.2, // 土壤导热系数
                buriedDepth:1.4, // 埋设深度                 
            }], // 方案列表

            baseUrl: this.$store.state.assetsUrl,
            thermal:false, // 导热系数对话框
            thermalMode:"table", // 导热计算模式

            defaultSug:{}, // 默认方案
            updateFlag:false, // 是否可以编辑
        }
    },
    mounted(){
        this.init_data();
    },
    methods:{
        // 初始化数据
        init_data(){
            if(this.globalConfig){
                if(this.globalConfig.buriedParamSugs){
                    this.suggestions=JSON.parse(JSON.stringify(this.globalConfig.buriedParamSugs));
                }
                let soilParam=this.globalConfig.pipeModel.soilParam;
                if(soilParam){
                    this.defaultSug=soilParam;
                    this.curSuggestion=JSON.parse(JSON.stringify(this.defaultSug));
                }
            }
        },
       // 新增
        addSuggestion(){
            let suglength=this.suggestions.length;
            let id=this.suggestions[suglength-1].id+1;
            this.curSuggestion={
                id:id,
                name:"默认方案"+id, // 保温材料名称
                soilQuality:"粗沙", // 土质选择
                soilMoistSat:0.3, // 土壤含水饱和率
                soilPorosity:0, // 土壤孔隙率
                soilTempe:10, // 土壤温度
                soilThermConduct:1.2, // 土壤导热系数
                buriedDepth:1.4, // 埋设深度        
            }
            this.updateFlag=true;
        },
        // 更新
        updateSuggestion(){
            this.updateFlag=true;
        },
        // 取消保存
        cancelSuggestion(){
            let currentId=this.curSuggestion.id;
            let temp=_find(this.suggestions, function(o) { return o.id == currentId; });
            if(!temp){
                temp=this.suggestions[0];
            }
            this.curSuggestion=JSON.parse(JSON.stringify(temp));
            this.updateFlag=false;
        },

        // 保存方案
        saveSuggestion(){
            let temp=null;
            this.suggestions.forEach((item,index)=>{
                if(item.id == this.curSuggestion.id){
                    item=JSON.parse(JSON.stringify(this.curSuggestion));
                    temp=item;
                    this.$set(this.suggestions,index,item); // 更新表格
                }
            });
            // 如果存在该类型的材料，则更新，否则新增
            if(!temp){
                temp=JSON.parse(JSON.stringify(this.curSuggestion));
                this.suggestions.push(temp);
            }
            // 关闭修改
            this.updateFlag=false;

            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(temp);

            // 触发父元素数组更新
            this.globalSuggestionChange();

            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });
        },
        // 方案选中改变
        suggestionChange(item){
            item=item||this.suggestions[0];
            this.curSuggestion=JSON.parse(JSON.stringify(item));
        },
        // 删除方案
        deleteSuggestion(){
            let id=this.curSuggestion.id;
            this.suggestions=_remove(this.suggestions, function(it) {  return it.id!=id;});
            // 恢复默认
            this.curSuggestion=JSON.parse(JSON.stringify(this.suggestions[0]));
            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(this.suggestions[0]);
            // 停止更新
            this.updateFlag=false;
        },
        // 设为默认方案
        defaultSuggestion(item){
            let tempGlobalConfig=JSON.parse(JSON.stringify(this.globalConfig));
            this.defaultSug=item
            tempGlobalConfig.pipeModel.soilParam=item;
            this.$store.commit("simulation/setGlobalConfig",tempGlobalConfig);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",tempGlobalConfig);
        },
        // 全局方案修改
        globalSuggestionChange(){
            let temp=JSON.parse(JSON.stringify(this.globalConfig));
            temp.buriedParamSugs=this.suggestions;
            this.$store.commit("simulation/setGlobalConfig",temp);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",temp);
        },
        // 计算土壤导热系数
        calculateThermal(){
            this.thermal=true;
            this.thermalMode="calculate";
        },
        // 查表导热系数
        searchThermal(){
            this.thermal=true;
            this.thermalMode="table";
        },
        // 土壤导热系数确认
        thermalOk(){

        }
    }
}
</script>

<style lang="scss">
.buriedParamSet{
    width: 720px!important;

    .calculate-btn{
        margin-left: 15px;
    }

    .attr_common{
        display: flex;
        flex-wrap: wrap;

        .el-form-item{
            width: 50%;
            margin-right: 0;

            .el-input{
                width: 120px;
            }
        }

        .form-row{
            width: 100%;
        }
    }

    .foot-btn{
        margin-top: 10px;
    }
}
/** 导热系数设置面板 */
.thermal-dialog{
    overflow: hidden;

    .el-dialog{
        border-radius: 4px;
        width: max-content;

         .el-dialog__header{
            padding: 5px 10px 5px 10px;
            color: #fff;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            background: #2c99db;

            .el-dialog__headerbtn{
                top: 5px;
                right: 5px;

                .el-dialog__close{
                    color: #fff;
                }
            }

        }
        .el-dialog__body{
            padding:20px;
            min-height: 100px;
            position: relative;

            .el-form-item{
                margin-bottom:10px;
            }

            .el-input{
                width:150px;
                .el-input__inner{
                    height: 35px;
                    line-height: 35px;
                }

            }
            .el-input__suffix-inner{
                top: 50%;
                position: relative;
                transform: translateY(-50%);
                display: inline-block;
            }
            .el-button{
                span{
                    cursor: pointer;
                }
            }

            .input-box{
                margin-right: 10px;
            }

            .foot-btn{
                text-align: right;
            }

            .thermal-img{
                width: 580px;
                height: 600px;
            }
        }

    }
}
</style>